import { IconChevron } from '~/vinovest-design-system/components/Icons';

interface ConnectSourceOptionProps {
    icon: JSX.Element;
    title: string;
    subtitle: string;
    onClick?: () => void;
    disabled?: boolean;
}

/** Button style for the account connect modal. */
export const ConnectSourceOption = ({ icon, title, subtitle, onClick, disabled }: ConnectSourceOptionProps) => {
    return (
        <button
            type={'button'}
            className={
                'flex w-full justify-between group items-center py-4 px-4 sm:px-6 disabled:pointer-events-none disabled:opacity-30'
            }
            onClick={onClick}
            disabled={disabled}
        >
            <div className={'flex items-center'}>
                <div className={'bg-platinum-800 p-3 rounded-full text-center mr-4'}>{icon}</div>
                <div className={'text-left'}>
                    <p className={'text-14 text-platinum-800'}>{title}</p>
                    <p className={'text-12 text-neutrals-400'}>{subtitle}</p>
                </div>
            </div>
            <div>
                <IconChevron
                    width={'15px'}
                    height={'10px'}
                    className={'opacity-20 -rotate-90 group-hover:translate-x-2 transition-all'}
                    stroke={'#242E35'}
                />
            </div>
        </button>
    );
};
